import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import _ from 'lodash';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { size, media } from '@deerplusofficial/pos-helper';
import actions from '../../actions';
import withCartProps from '../../assist/withCartProps';
import Toolbar from '../Toolbar/Toolbar';
import CartToolBar from './CartToolBar';
import CartFooter from './CartFooter';
import CartBody from './CartBody';

const Container = styled(Toolbar)`
  ${media(
    'tablet',
    css`
      display: flex;
      flex-shrink: 0;
      position: static;
      height: auto;
      width: 30%;
      min-width: ${size.cart};
      max-width: 360px;
      transform: none;
      transition: none;
    `
  )};
`;

class Cart extends Component {
  static propTypes = {
    active: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  static defaultProps = {
    active: false,
    readonly: false,
    cart: {},
    order: {},
  };

  get disableCheckout() {
    const {
      readonly,
      cart,
      order: { customPrice },
    } = this.props;

    return readonly || (_.size(cart.items) <= 0 && customPrice === 0);
  }

  render() {
    const { active, readonly, cart, toggleCart } = this.props;

    return (
      <Container
        in={active}
        active={active}
        readonly={readonly}
        onToggleClick={toggleCart}
        label={`訂單內容(${_.size(cart.items)})`}
      >
        <CartToolBar readonly={readonly} />
        <CartBody readonly={readonly} />
        <CartFooter readonly={readonly} disabled={this.disableCheckout} />
      </Container>
    );
  }
}

const { toggle: toggleCart } = actions.cart;

export default fp.compose(
  withCartProps(),
  connect(
    null,
    {
      toggleCart,
    }
  )
)(Cart);



// WEBPACK FOOTER //
// ./src/components/Cart/Cart.js